<div class="input-group">
    <span class="input-group-text">{{ selectedDialCode }}</span>
    <input
      type="text"
      nbInput
      class="form-control phone-input"
      [placeholder]="customPlaceholder"
      style="max-width: 400px; padding-left: 50px; font-size: 16px;"
      [formControl]="phoneControl"
      [style.width]="inputWidth"
      [ngClass]="{ 'is-invalid': phoneControl.invalid && phoneControl.touched }"
      ng2TelInput
      [ng2TelInputOptions]="{
        initialCountry: selectedCountry || initialCountry,
        separateDialCode: true
      }"
      (intlTelInputObject)="telInputObject($event)"
      (countryChange)="onCountryChange($event)"
      (input)="updatePhoneNumber()"
    />
  </div>
  <div class="text-danger mt-1" *ngIf="phoneControl.invalid && phoneControl.touched">
    <small *ngIf="phoneControl.hasError('phoneInvalid')">Incorrect phone number for selected country</small>
  </div>
  